const externalRoutes = {
  improve_submissions: 'https://www.verblio.com/blog/mastering-requests-important-verblio-experience',
  seo_requirements: 'https://help.verblio.com/my-account/making-requests/adding-seo-requirements-to-your-requests',
  direct_assignment: 'https://help.verblio.com/my-account/making-requests/direct-assignment-help-link',
}

export function externalRoute(path: string, id: string | number = null): any {
  let route = externalRoutes[path]
  if (id && route.includes(':id')) { route = route.replace(':id', id) }
  return route
}
